import type { SortDirection } from '../../../../../utils/sortDirection';
import type { IEmployment } from '../../../../interfaces/employment';
import type { IPractitioner } from '../../../../interfaces/practitioner';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../translate';
import { SelectableSortableTable } from '../../../../userDataManagement/SelectableSortableTable';

interface IAddEmploymentsTableProps {
    employments: IEmployment[];
    onChange: (selectedServiceOrganizationConsumersOrganizationIds: string[]) => Promise<void>;
    onSort: (sortKey: string, sortDirection: SortDirection) => Promise<void>;
    selectedEmployments: string[];
    sortDirection: SortDirection;
}

export function AddEmploymentsTable(props: IAddEmploymentsTableProps) {
    return (
        <SelectableSortableTable
            onSelect={props.onChange}
            onSort={props.onSort}
            selectedRowKeys={props.selectedEmployments}
            sortDirection={props.sortDirection}
            sortKey="name"
            tableHeaders={getTableheaders()}
            tableRows={getTableRows()}
        />
    );

    function getTableheaders() {
        return [
            { columnKey: 'name', children: translateKey('common.name'), isSortable: true },
            { columnKey: 'profession', children: translateKey('common.profession') },
        ];
    }

    function getTableRows() {
        return props.employments.map((employment) => ({
            rowKey: employment.id,
            cells: [
                {
                    children: getDisplayName(
                        employment.practitioner as IPractitioner,
                        false,
                        'familyNameCommaInitials'
                    ),
                },
                { children: translateKey(`professionEnum.${employment.profession}`) },
            ],
        }));
    }
}
